import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';
import { TransferUnit, TransferUnitSearchCommand } from '../../models/inventory/transfer-unit';

@Injectable({
  providedIn: 'root',
})
export class TransferUnitProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/transfer-unit';

  public getAll(): Observable<ApiResponse<TransferUnit[]>> {
    return this.httpClient.get<ApiResponse<TransferUnit[]>>(this.baseUrl + '/all');
  }

  public search(
    command: TransferUnitSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<TransferUnit>>> {
    let queryParams = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (sortField) {
      queryParams += `&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}`;
    }

    return this.httpClient.post<ApiResponse<PaginatedApiResponse<TransferUnit>>>(this.baseUrl + '/search' + queryParams, command);
  }

  public insert(body: TransferUnit): Observable<ApiResponse<TransferUnit>> {
    return this.httpClient.post<ApiResponse<TransferUnit>>(this.baseUrl, body);
  }

  public getById(id: string): Observable<ApiResponse<TransferUnit>> {
    return this.httpClient.get<ApiResponse<TransferUnit>>(`${this.baseUrl}/${id}`);
  }

  public updateStatus(id: string, status: number): Observable<ApiResponse<TransferUnit>> {
    const body = {
      newStatus: status,
    };
    return this.httpClient.patch<ApiResponse<TransferUnit>>(`${this.baseUrl}/${id}/status`, body);
  }

  public transferUnitReport(id: string): Observable<Blob> {
    const queryParams = `?generatePdf=true`;
    return this.httpClient.get(`${this.baseUrl}/report/${id}${queryParams}`, { responseType: 'blob' });
  }
}
